export const getRestoringState = state => state.restoringState;
export const getFormValues = state => ({
  productName: state.productName,
  productDescription: state.productDescription,
  keywords: state.keywords,
  excludeOldWorkItems: state.excludeOldWorkItems,
  customKeywordsMustMatch: state.customKeywordsMustMatch,
  activityAutoSelectCount: state.activityAutoSelectCount,
});
